import { useEffect } from "react";
import LogUtil from "@/betby/utils/LogUtil";

interface UseSportBalanceUpdateListenerParams {
  refreshBalance: () => Promise<void>;
}

/**
 * 监听外部窗口发来的余额更新消息，并触发静默余额刷新。
 */
export function useSportBalanceUpdateListener({
  refreshBalance,
}: UseSportBalanceUpdateListenerParams) {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      try {
        const { data } = event;
        if (!data) return;

        if (
          data.type === "sport_balance_update" ||
          data.key === "sport_balance_update"
        ) {
          void refreshBalance();
        }
      } catch (error) {
        LogUtil.error("[BetbyRenderer] 处理消息异常:", error);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [refreshBalance]);
}
